exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-status[data-v-6bed3c51] {\n  padding: 10px 6px;\n}\n.col-status .lb-status[data-v-6bed3c51] {\n  color: #fff;\n  padding: 3px 9px;\n  border-radius: 3px;\n  text-align: center;\n}", ""]);

// exports
